import { createTabSlice } from '../helpers';

const tabs = [
  {
    label: 'Labelling Candidates',
    icon: 'CreateIcon',
    component: 'DataCurationDashboard/LabellingCandidates',
    actionBar: [],
  },
  {
    label: 'Staged for Splitting',
    icon: 'PostAddIcon',
    component: 'DataCurationDashboard/StagedForSplitting',
    actionBar: [
      {
        type: 'button',
        component: 'DataCurationDashboard/SplitSequencesButton',
      },
    ],
  },
  {
    label: 'Pending',
    icon: 'AccessTimeIcon',
    component: 'DataCurationDashboard/Pending',
  },
];

export const tabSlice = createTabSlice({ name: 'dataCurationDashboard/tabs', tabs });
